/**
 * QuickStore Slider V1
 * Mobil yatay slider erişilebilirlik ve klavye desteği
 */

(() => {
  'use strict';

  const SELECTOR = '[data-qs-slider]';

  function initializeSlider(slider) {
    if (!(slider instanceof HTMLElement)) return;
    if (slider.dataset.qsSliderReady === 'true') return;

    slider.dataset.qsSliderReady = 'true';
    slider.setAttribute('role', 'region');
    slider.setAttribute('tabindex', '0');

    if (!slider.hasAttribute('aria-label')) {
      slider.setAttribute('aria-label', 'Ürün kaydırıcısı');
    }

    slider.addEventListener('keydown', (event) => {
      if (window.innerWidth > 749) return;

      const firstItem = slider.firstElementChild;
      const itemWidth = firstItem
        ? firstItem.getBoundingClientRect().width
        : slider.clientWidth * 0.85;

      const computedStyle = window.getComputedStyle(slider);
      const gap = Number.parseFloat(computedStyle.columnGap || computedStyle.gap) || 14;
      const distance = itemWidth + gap;

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        slider.scrollBy({
          left: distance,
          behavior: 'smooth'
        });
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        slider.scrollBy({
          left: -distance,
          behavior: 'smooth'
        });
      }
    });
  }

  function initializeAllSliders(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initializeSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllSliders();
    });
  } else {
    initializeAllSliders();
  }

  /* Shopify tema düzenleyicisinde bölüm yeniden yüklendiğinde */
  document.addEventListener('shopify:section:load', (event) => {
    initializeAllSliders(event.target);
  });
})();